export const environment = {
  production: false,
  // apiUrl: 'https://localhost:5001/api',
  // apiUrl: 'https://localhost:44362/api',
  apiUrl: 'https://digomg.com.br/digoAPI/api',
};
